'use client';

import Link from 'next/link';

export default function VerificationCodePage() {
  return (
    <>
      <div className="user-form-card">
        <div className="user-form-title">
          <h2>ادخل الكود</h2>
          <p>أدخل الكود</p>
        </div>
        <form className="user-form">
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              placeholder="ادخل الكود "
            />
          </div>
          <div className="form-button">
            <button className="ps-btn ps-btn--warning">
              ادخل الباسورد الجديد
            </button>
          </div>
        </form>
      </div>
      <div className="user-form-remind">
        <p>
          <Link href="/login">العودة الي تسجيل الدخول</Link>
        </p>
      </div>
      <div className="user-form-footer">
        <p>جميع الحقوق محفوظة شركه زمزم © 2024</p>
      </div>
    </>
  );
}
